import React from "react";
import { SafeAreaView, View, Text, TouchableOpacity, Image } from "react-native";
import { useLocation } from "react-router-dom";
import AppColors from "../Constants/AppColors";
import AppFonts from "../Constants/AppFonts";
import AppImages from "../Constants/AppImages";
import useAppNavigation from "../Routes/useAppNavigation";

/**
 * ComingSoon - mobile placeholder for production routes whose mobile screen
 * does not exist yet (or can't compile because of missing native deps).
 * Keeps every production route name resolvable so navigation never dead-ends.
 * The page title is derived from the current URL path.
 */
const prettify = (path) => {
  const last = (path || "").split("/").filter(Boolean).pop() || "Page";
  // split CamelCase / separators into words
  return last
    .replace(/[-_]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .trim();
};

const ComingSoon = () => {
  const navigation = useAppNavigation();
  const location = useLocation();
  const title = prettify(location.pathname);

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.white }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: AppColors.white,
          height: 58,
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 0, height: 3 },
          shadowOpacity: 1,
          shadowRadius: 10,
          elevation: 6,
        }}
      >
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={AppImages.Backbtn} style={{ width: 8, height: 15 }} resizeMode="contain" />
        </TouchableOpacity>
        <Text
          style={{
            color: AppColors.brown1,
            fontSize: 16,
            fontFamily: AppFonts.OverpassMedium,
            marginLeft: 20,
          }}
        >
          {title}
        </Text>
      </View>

      <View style={{ flex: 1, alignItems: "center", justifyContent: "center", padding: 30 }}>
        <Text
          style={{
            color: AppColors.brown1,
            fontSize: 20,
            fontFamily: AppFonts.OverpassBold,
            textAlign: "center",
          }}
        >
          {title}
        </Text>
        <Text
          style={{
            color: AppColors.dualbrown,
            fontSize: 14,
            fontFamily: AppFonts.OverpassRegular,
            textAlign: "center",
            marginTop: 10,
          }}
        >
          This screen is coming soon in the mobile view.
        </Text>
      </View>
    </SafeAreaView>
  );
};

export default ComingSoon;
